module.exports = __webpack_public_path__ + "static/media/winno-video.21cea237.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/LandingFlow/assets/winno-video.mp4
// module id = 933
// module chunks = 0